/**
 * Mock data for Professor Analytics Dashboard demo.
 * Subject: NCERT Physics (Class 11 & 12) — NEET preparation context.
 * Featured student: Jash Shah
 */

// ─── Student roster (30 students) ─────────────────────────────────────────────

export interface MockStudent {
  id: string;
  name: string;
  pagesRead: number;
  readingHours: number;
  questionsAsked: number;
  lastActive: string; // relative like "2 hours ago"
  lastActiveDate: string; // ISO date
  highlights: number;
  notesCount: number;
}

// Mock institute ID — used in URL routing
export const MOCK_INSTITUTE_ID = 'inst-7f3a9b2e-4c1d-4e8f-a5b6-3d2c1e0f9a8b';

// Jash Shah's UUID — used for drill-down detection
export const JASH_ID = 'a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d';

export const students: MockStudent[] = [
  { id: JASH_ID, name: 'Jash Shah', pagesRead: 187, readingHours: 24.5, questionsAsked: 38, lastActive: '2 hours ago', lastActiveDate: '2026-04-08', highlights: 22, notesCount: 8 },
  { id: 'b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e', name: 'Ananya Iyer', pagesRead: 162, readingHours: 19.2, questionsAsked: 25, lastActive: '5 hours ago', lastActiveDate: '2026-04-08', highlights: 15, notesCount: 5 },
  { id: 'c3d4e5f6-a7b8-4c9d-0e1f-2a3b4c5d6e7f', name: 'Rohan Mehta', pagesRead: 145, readingHours: 17.8, questionsAsked: 31, lastActive: '1 day ago', lastActiveDate: '2026-04-07', highlights: 18, notesCount: 6 },
  { id: 'd4e5f6a7-b8c9-4d0e-1f2a-3b4c5d6e7f8a', name: 'Priya Deshmukh', pagesRead: 158, readingHours: 20.1, questionsAsked: 12, lastActive: '3 hours ago', lastActiveDate: '2026-04-08', highlights: 8, notesCount: 3 },
  { id: 'e5f6a7b8-c9d0-4e1f-2a3b-4c5d6e7f8a9b', name: 'Arjun Nair', pagesRead: 134, readingHours: 15.6, questionsAsked: 22, lastActive: '1 day ago', lastActiveDate: '2026-04-07', highlights: 14, notesCount: 7 },
  { id: 'f6a7b8c9-d0e1-4f2a-3b4c-5d6e7f8a9b0c', name: 'Kavya Sharma', pagesRead: 171, readingHours: 22.3, questionsAsked: 29, lastActive: '4 hours ago', lastActiveDate: '2026-04-08', highlights: 20, notesCount: 9 },
  { id: '17a8b9c0-d1e2-4f3a-4b5c-6d7e8f9a0b1c', name: 'Aditya Patel', pagesRead: 98, readingHours: 11.2, questionsAsked: 8, lastActive: '3 days ago', lastActiveDate: '2026-04-05', highlights: 4, notesCount: 1 },
  { id: '28b9c0d1-e2f3-4a4b-5c6d-7e8f9a0b1c2d', name: 'Sneha Reddy', pagesRead: 112, readingHours: 13.5, questionsAsked: 18, lastActive: '1 day ago', lastActiveDate: '2026-04-07', highlights: 11, notesCount: 4 },
  { id: '39c0d1e2-f3a4-4b5c-6d7e-8f9a0b1c2d3e', name: 'Vikram Singh', pagesRead: 78, readingHours: 8.4, questionsAsked: 5, lastActive: '5 days ago', lastActiveDate: '2026-04-03', highlights: 2, notesCount: 0 },
  { id: '4ad1e2f3-a4b5-4c6d-7e8f-9a0b1c2d3e4f', name: 'Ishita Gupta', pagesRead: 189, readingHours: 25.1, questionsAsked: 42, lastActive: '1 hour ago', lastActiveDate: '2026-04-08', highlights: 25, notesCount: 11 },
  { id: '5be2f3a4-b5c6-4d7e-8f9a-0b1c2d3e4f5a', name: 'Rahul Joshi', pagesRead: 125, readingHours: 14.8, questionsAsked: 15, lastActive: '2 days ago', lastActiveDate: '2026-04-06', highlights: 9, notesCount: 3 },
  { id: '6cf3a4b5-c6d7-4e8f-9a0b-1c2d3e4f5a6b', name: 'Meera Kulkarni', pagesRead: 143, readingHours: 16.9, questionsAsked: 20, lastActive: '6 hours ago', lastActiveDate: '2026-04-08', highlights: 13, notesCount: 5 },
  { id: '7da4b5c6-d7e8-4f9a-0b1c-2d3e4f5a6b7c', name: 'Siddharth Rao', pagesRead: 156, readingHours: 18.7, questionsAsked: 27, lastActive: '3 hours ago', lastActiveDate: '2026-04-08', highlights: 16, notesCount: 7 },
  { id: '8eb5c6d7-e8f9-4a0b-1c2d-3e4f5a6b7c8d', name: 'Tanvi Bhatt', pagesRead: 91, readingHours: 10.3, questionsAsked: 9, lastActive: '4 days ago', lastActiveDate: '2026-04-04', highlights: 5, notesCount: 2 },
  { id: '9fc6d7e8-f9a0-4b1c-2d3e-4f5a6b7c8d9e', name: 'Harsh Agarwal', pagesRead: 167, readingHours: 21.0, questionsAsked: 33, lastActive: '2 hours ago', lastActiveDate: '2026-04-08', highlights: 19, notesCount: 8 },
  { id: 'a0d7e8f9-a0b1-4c2d-3e4f-5a6b7c8d9e0f', name: 'Diya Menon', pagesRead: 138, readingHours: 16.2, questionsAsked: 17, lastActive: '1 day ago', lastActiveDate: '2026-04-07', highlights: 10, notesCount: 4 },
  { id: 'b1e8f9a0-b1c2-4d3e-4f5a-6b7c8d9e0f1a', name: 'Karthik Venkat', pagesRead: 42, readingHours: 4.1, questionsAsked: 2, lastActive: '8 days ago', lastActiveDate: '2026-03-31', highlights: 1, notesCount: 0 },
  { id: 'c2f9a0b1-c2d3-4e4f-5a6b-7c8d9e0f1a2b', name: 'Nisha Pandey', pagesRead: 153, readingHours: 18.0, questionsAsked: 21, lastActive: '5 hours ago', lastActiveDate: '2026-04-08', highlights: 14, notesCount: 6 },
  { id: 'd3a0b1c2-d3e4-4f5a-6b7c-8d9e0f1a2b3c', name: 'Aman Tiwari', pagesRead: 119, readingHours: 13.1, questionsAsked: 14, lastActive: '2 days ago', lastActiveDate: '2026-04-06', highlights: 7, notesCount: 3 },
  { id: 'e4b1c2d3-e4f5-4a6b-7c8d-9e0f1a2b3c4d', name: 'Riya Kapoor', pagesRead: 174, readingHours: 23.0, questionsAsked: 35, lastActive: '1 hour ago', lastActiveDate: '2026-04-08', highlights: 21, notesCount: 10 },
  { id: 'f5c2d3e4-f5a6-4b7c-8d9e-0f1a2b3c4d5e', name: 'Kunal Saxena', pagesRead: 65, readingHours: 6.8, questionsAsked: 4, lastActive: '6 days ago', lastActiveDate: '2026-04-02', highlights: 2, notesCount: 0 },
  { id: '16d3e4f5-a6b7-4c8d-9e0f-1a2b3c4d5e6f', name: 'Pooja Mishra', pagesRead: 131, readingHours: 15.0, questionsAsked: 19, lastActive: '1 day ago', lastActiveDate: '2026-04-07', highlights: 12, notesCount: 5 },
  { id: '27e4f5a6-b7c8-4d9e-0f1a-2b3c4d5e6f7a', name: 'Vivek Chauhan', pagesRead: 148, readingHours: 17.5, questionsAsked: 23, lastActive: '4 hours ago', lastActiveDate: '2026-04-08', highlights: 15, notesCount: 6 },
  { id: '38f5a6b7-c8d9-4e0f-1a2b-3c4d5e6f7a8b', name: 'Shruti Bose', pagesRead: 105, readingHours: 12.0, questionsAsked: 11, lastActive: '3 days ago', lastActiveDate: '2026-04-05', highlights: 6, notesCount: 2 },
  { id: '49a6b7c8-d9e0-4f1a-2b3c-4d5e6f7a8b9c', name: 'Nikhil Verma', pagesRead: 160, readingHours: 19.8, questionsAsked: 26, lastActive: '3 hours ago', lastActiveDate: '2026-04-08', highlights: 17, notesCount: 7 },
  { id: '5ab7c8d9-e0f1-4a2b-3c4d-5e6f7a8b9c0d', name: 'Anjali Thakur', pagesRead: 88, readingHours: 9.6, questionsAsked: 7, lastActive: '5 days ago', lastActiveDate: '2026-04-03', highlights: 3, notesCount: 1 },
  { id: '6bc8d9e0-f1a2-4b3c-4d5e-6f7a8b9c0d1e', name: 'Dev Malhotra', pagesRead: 140, readingHours: 16.5, questionsAsked: 20, lastActive: '7 hours ago', lastActiveDate: '2026-04-08', highlights: 11, notesCount: 4 },
  { id: '7cd9e0f1-a2b3-4c4d-5e6f-7a8b9c0d1e2f', name: 'Simran Kaur', pagesRead: 176, readingHours: 22.8, questionsAsked: 30, lastActive: '2 hours ago', lastActiveDate: '2026-04-08', highlights: 19, notesCount: 9 },
  { id: '8de0f1a2-b3c4-4d5e-6f7a-8b9c0d1e2f3a', name: 'Rajat Dubey', pagesRead: 55, readingHours: 5.5, questionsAsked: 3, lastActive: '7 days ago', lastActiveDate: '2026-04-01', highlights: 1, notesCount: 0 },
  { id: '9ef1a2b3-c4d5-4e6f-7a8b-9c0d1e2f3a4b', name: 'Aditi Choudhary', pagesRead: 129, readingHours: 14.5, questionsAsked: 16, lastActive: '1 day ago', lastActiveDate: '2026-04-07', highlights: 10, notesCount: 4 },
];

// ─── KPI Card 1: Reading Engagement ───────────────────────────────────────────

export const readingKPI = {
  readYesterday: 22,
  totalStudents: 30,
  avgPagesPerStudent: 11,
  chaptersActive: [
    { chapter: 'Ch 3: Current Electricity', studentsReading: 14, avgPages: 8 },
    { chapter: 'Ch 4: Moving Charges and Magnetism', studentsReading: 9, avgPages: 6 },
    { chapter: 'Ch 11: Dual Nature of Radiation and Matter', studentsReading: 5, avgPages: 4 },
    { chapter: 'Ch 5: Laws of Motion', studentsReading: 3, avgPages: 3 },
  ],
  // Students sorted by least pages read yesterday
  leastReadStudents: [
    { name: 'Karthik Venkat', pages: 0, lastActive: '8 days ago' },
    { name: 'Rajat Dubey', pages: 0, lastActive: '7 days ago' },
    { name: 'Kunal Saxena', pages: 0, lastActive: '6 days ago' },
    { name: 'Vikram Singh', pages: 2, lastActive: '5 days ago' },
    { name: 'Anjali Thakur', pages: 3, lastActive: '5 days ago' },
    { name: 'Tanvi Bhatt', pages: 4, lastActive: '4 days ago' },
    { name: 'Aditya Patel', pages: 5, lastActive: '3 days ago' },
    { name: 'Shruti Bose', pages: 6, lastActive: '3 days ago' },
  ],
};

// ─── KPI Card 2: Common Question Themes (Yesterday) ──────────────────────────

export interface QuestionTheme {
  concept: string;
  chapter: string;
  studentCount: number;
  totalQuestions: number;
  sampleQuestions: string[];
}

export const questionThemes: QuestionTheme[] = [
  {
    concept: "Kirchhoff's Laws",
    chapter: 'Ch 3: Current Electricity',
    studentCount: 7,
    totalQuestions: 12,
    sampleQuestions: [
      "In Kirchhoff's loop rule, how do I know which direction to go around the loop?",
      "Why does current split in a parallel circuit but voltage stays same?",
      "If I apply KVL wrong direction, will I get a wrong answer or just negative signs?",
    ],
  },
  {
    concept: 'EMF vs Potential Difference',
    chapter: 'Ch 3: Current Electricity',
    studentCount: 5,
    totalQuestions: 8,
    sampleQuestions: [
      "What's the actual difference between EMF and terminal voltage? Both are in volts.",
      "Why does a battery's voltage drop when I connect it to a circuit?",
      "Sir, EMF is called 'force' but it's measured in volts — that makes no sense?",
    ],
  },
  {
    concept: 'Magnetic Force on Moving Charges',
    chapter: 'Ch 4: Moving Charges and Magnetism',
    studentCount: 4,
    totalQuestions: 7,
    sampleQuestions: [
      "Why does a charged particle go in a circle in a magnetic field but straight in an electric field?",
      "If magnetic force is always perpendicular, how does it make the particle curve?",
      "What happens if velocity is parallel to the magnetic field?",
    ],
  },
  {
    concept: 'Photoelectric Effect',
    chapter: 'Ch 11: Dual Nature of Radiation and Matter',
    studentCount: 4,
    totalQuestions: 6,
    sampleQuestions: [
      "In photoelectric effect, why does increasing intensity not increase KE of electrons? More light = more energy no?",
      "What is threshold frequency physically? Why can't many low-energy photons add up?",
    ],
  },
  {
    concept: "Newton's Third Law",
    chapter: 'Ch 5: Laws of Motion',
    studentCount: 3,
    totalQuestions: 5,
    sampleQuestions: [
      "If action and reaction are equal and opposite, why does anything move at all?",
      "If I push a wall and it doesn't move, where is the reaction force?",
      "If earth pulls me down and I pull earth up, why doesn't earth come towards me?",
    ],
  },
];

// ─── Student Detail: Jash Shah (id: '1') ─────────────────────────────────────

// Reading time this week — daily breakdown per subject
export const jashReadingTime = [
  { day: 'Mon', 'Current Electricity': 2.1, 'Magnetism': 0.5, 'Optics': 0, 'Mechanics': 0 },
  { day: 'Tue', 'Current Electricity': 1.8, 'Magnetism': 1.2, 'Optics': 0, 'Mechanics': 0.3 },
  { day: 'Wed', 'Current Electricity': 0.5, 'Magnetism': 0, 'Optics': 0, 'Mechanics': 0 },
  { day: 'Thu', 'Current Electricity': 2.5, 'Magnetism': 0.8, 'Optics': 0, 'Mechanics': 0 },
  { day: 'Fri', 'Current Electricity': 1.2, 'Magnetism': 1.5, 'Optics': 0.5, 'Mechanics': 0 },
  { day: 'Sat', 'Current Electricity': 0, 'Magnetism': 2.0, 'Optics': 1.0, 'Mechanics': 0.5 },
  { day: 'Sun', 'Current Electricity': 1.5, 'Magnetism': 0.3, 'Optics': 0, 'Mechanics': 1.2 },
];

export const jashSubjects = ['Current Electricity', 'Magnetism', 'Optics', 'Mechanics'];
export const subjectColors: Record<string, string> = {
  'Current Electricity': '#06B6D4',
  'Magnetism': '#8B5CF6',
  'Optics': '#F59E0B',
  'Mechanics': '#10B981',
};

// Struggle themes this week (cross-referenced with FSRS)
export interface StruggleTheme {
  concept: string;
  chapter: string;
  questionsThisWeek: number;
  status: 'struggling' | 'unverified' | 'mastered';
  fsrsState?: string;
  lastRating?: string;
  sampleQuestion: string;
}

export const jashStruggleThemes: StruggleTheme[] = [
  {
    concept: "Kirchhoff's Loop Rule",
    chapter: 'Ch 3: Current Electricity',
    questionsThisWeek: 4,
    status: 'struggling',
    fsrsState: 'relearning',
    lastRating: 'forgot',
    sampleQuestion: "How do I know which direction to traverse the loop in KVL?",
  },
  {
    concept: 'EMF vs Terminal Voltage',
    chapter: 'Ch 3: Current Electricity',
    questionsThisWeek: 3,
    status: 'struggling',
    fsrsState: 'learning',
    lastRating: 'fuzzy',
    sampleQuestion: "Why does battery voltage drop under load?",
  },
  {
    concept: 'Biot-Savart vs Ampere\'s Law',
    chapter: 'Ch 4: Moving Charges and Magnetism',
    questionsThisWeek: 2,
    status: 'unverified',
    sampleQuestion: "I don't understand why we need both. Aren't they doing the same thing?",
  },
  {
    concept: 'Cyclotron Working',
    chapter: 'Ch 4: Moving Charges and Magnetism',
    questionsThisWeek: 1,
    status: 'unverified',
    sampleQuestion: "Why does the radius increase in a cyclotron if B is constant?",
  },
];

// Overconfidence data
export const jashOverconfidence = {
  totalReviews: 18,
  overconfidenceEvents: 5,
  overconfidenceRate: 0.28, // 28%
  concepts: [
    { concept: 'Work-Energy Theorem', confidenceAvg: 4.2, timesOverconfident: 2, lastRating: 'forgot' },
    { concept: 'Ohm\'s Law (non-ohmic conductors)', confidenceAvg: 4.0, timesOverconfident: 2, lastRating: 'forgot' },
    { concept: 'Newton\'s Second Law (variable mass)', confidenceAvg: 4.5, timesOverconfident: 1, lastRating: 'fuzzy' },
  ],
};

// Top stuck concepts (max 5)
export interface StuckConcept {
  concept: string;
  reason: string;
  reps: number;
  currentState: string;
}

export const jashStuckConcepts: StuckConcept[] = [
  { concept: "Kirchhoff's Loop Rule", reason: 'Had it, lost it', reps: 5, currentState: 'relearning' },
  { concept: 'EMF vs Terminal Voltage', reason: 'Keeps forgetting', reps: 4, currentState: 'learning' },
  { concept: 'Work-Energy Theorem', reason: 'Overconfident — rates high but forgets', reps: 3, currentState: 'relearning' },
];

// AI Chat Summary — factual, actionable, no dramatic claims
export const jashAISummary = {
  struggleThemes: [
    {
      concept: "Kirchhoff's Loop Rule",
      detail: "Asked 4 times this week. Questions evolved from \"what is KVL?\" to \"how do I pick loop direction?\" — understanding the rule but struggling with application.",
    },
    {
      concept: "EMF vs Terminal Voltage",
      detail: "Asked 3 times. Core confusion: why voltage drops under load. Questions remain at the same level — hasn't progressed past the basic distinction.",
    },
  ],
  studyPattern: [
    "9.6 hours on Current Electricity across 7 sessions this week",
    "Started exploring Magnetism mid-week — Biot-Savart, cyclotron",
    "No engagement with Ray Optics or Wave Optics this week",
  ],
  questionEvolution: "Questions on Current Electricity progressed from basic Ohm's law to Wheatstone bridge and internal resistance problems. Magnetism questions are still foundational.",
};

// ─── Per-student data generator (for other students in drill-down) ────────────

export function getStudentById(id: string) {
  return students.find(s => s.id === id);
}

// Cohort summary stats
export const cohortStats = {
  name: 'Physics Batch A — NEET 2026',
  subject: 'NCERT Physics (Class 11 & 12)',
  totalStudents: 30,
  totalChapters: 15,
  bookTitle: 'NCERT Physics Part I & II',
};
